import { render } from "./SuccessMsg.vue?vue&type=template&id=66fa2f4a"
import script from "./SuccessMsg.vue?vue&type=script&lang=js"
export * from "./SuccessMsg.vue?vue&type=script&lang=js"

import exportComponent from "/home/marc/E09/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__